import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

import '../components/Home/Home.scss';
import './AllCategories.scss';

import { categories } from '../components/Home/legacyCategories';
import { nameToSlug } from '../utils/categoriesMap';
import { trackOpenCategory } from '../utils/trackActivity';

// Secondary entry point for the full 18-category legacy taxonomy — moved
// out of Home's primary discovery path during the fashion-first Home
// redesign (2026-09). Nothing about the taxonomy itself changed: same 18
// categories, same slugs, same /category/:slug destination. Reuses Home's
// existing .home__categories* grid styling (Home.scss) so this stays a
// same-day addition rather than a new design.
export default function AllCategories() {
  return (
    <div className="home all-categories-page">
      <Helmet>
        <title>Інші категорії — Cvanto</title>
        <meta
          name="description"
          content="Повний список категорій Cvanto: нерухомість, транспорт, гаджети, стиль, б'юті, малеча та інше."
        />
      </Helmet>

      <h1 className="all-categories-page__title">Інші категорії</h1>

      <div className="home__categories-wrap is-open all-categories-page__grid">
        <div className="home__categories" role="list">
          {categories.map(({ name, image }, idx) => {
            const slug = nameToSlug[name];
            const to = slug
              ? `/category/${slug}`
              : `/search?tab=ads&category=${encodeURIComponent(name)}&sort=new`;

            return (
              <Link
                key={name}
                to={to}
                className="home__category"
                role="listitem"
                onClick={() => trackOpenCategory(name)}
              >
                <div className="home__category-circle" aria-hidden="true">
                  <img
                    className="home__category-img"
                    src={image}
                    alt=""
                    width={84}
                    height={84}
                    loading={idx < 6 ? 'eager' : 'lazy'}
                    decoding="async"
                    draggable={false}
                  />
                </div>
                <div className="home__category-name">{name}</div>
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
}
